import React from 'react';

const Heading = (title, data) => {
  return(

    <h4 className="card-title card-title-bottomline">
      <div className="row">
        <div className="col-12 col-md-8"><span>{title}</span>
          <div className="title-popover">
            <span></span>
              <span className="btn-popover" data-container="body" data-toggle="popover" data-placement="bottom" data-title="Qu’est ce que le Freeze Annatel?" data-content="Si vous quittez Israël pendant 1 mois ou plus, Annatel vous offre la possibilité de «&nbsp;freezer&nbsp;» votre ligne mobile. Votre ligne sera alors suspendue et vous ne paierez que 20 shekels par mois." data-original-title="" title="">

              </span>
              <span></span>
            </div>
        </div>
        <div className="col-12 col-md-4 text-md-right"><span>{data}</span></div>
      </div>
    </h4>
  )
}
export default Heading;



// WEBPACK FOOTER //
// ./src/components/Heading/Heading.js